import styles from './Spinner.module.scss';

const DOT_COUNT = 8;

export default function Spinner({ size = 'md', label = 'Učitavanje...' }) {
  return (
    <div className={styles.container}>
      <div className={`${styles.spinner} ${styles[`spinner--${size}`]}`}>
        {Array.from({ length: DOT_COUNT }).map((_, i) => (
          <div
            key={i}
            className={styles.dotWrapper}
            style={{ '--index': i }}
          >
            <span className={styles.dot} />
          </div>
        ))}
      </div>
      {label && <span className={styles.label}>{label}</span>}
    </div>
  );
}
